import React from 'react'
import { useTranslation } from 'react-i18next'
import Avatar from 'srcReact/components/common2/Avatar'
import { formatLastUpdateDate, getDateTimeFormat11 } from 'srcReact/helpers/datetimeHelper'
import { isCharacterCounter, isMobileScreen } from 'srcReact/helpers/utils'
import styles from './styles.module.scss'
import AnchorLink from 'srcReact/components/common2/AnchorLink'
import TooltipWrapper from 'srcReact/components/common2/TooltipWrapper'

function Header({
  feed,
  user,
  level,
  hasNewFeed,
  isMobile,
  isNative,
  isDesktop,
  type,
  renderOptions,
  isComment,
  showUserModal
}) {
  const { t } = useTranslation()
  return (
    <div className={`${styles.header} ${isComment && styles.headerInComment} ${hasNewFeed && styles.headerInNewFeed}`}>
      {user && (
        <Avatar
          userStatus={user.status}
          imgWrapperSize={level === 1 ? 'small52' : level === 2 ? 'small' : 'xsmall'}
          userId={user.id}
          profilePicture={user.profile_picture_url}
          firstname={user.firstname}
          lastname={user.lastname}
          onClickAction={() => showUserModal(user)}
          mimeType={user.mime_type}
          originalTag={user.original_tag}
          isOriginal={user.is_original}
          withExpertiseGroup={user.with_expertise_group}
        />
      )}

      <div className={`${styles.nameAndTime}`}>
        {user && (
          <div className={styles.newsFeedName}>
            <div
              role='button'
              onClick={() => (user.status === 'deleted' ? null : showUserModal(user))}
              className={styles.name}>
              {user.status === 'deleted'
                ? t('global.deletedUser')
                : isMobile && isCharacterCounter(user.firstname + user.lastname, 20)
                ? `${user.firstname} ${user.lastname.slice(0, 1)}.`
                : `${user.firstname} ${user.lastname}`}
            </div>
            {/* show time here only for general feed parent post */}
            {level === 1 &&
              type === 'organization' &&
              feed.relation &&
              (isDesktop ? (
                <TooltipWrapper
                  className='timezoneTooltip'
                  position={isMobileScreen() ? 'left top' : 'top center'}
                  triggerElement={<span className={styles.time}>{formatLastUpdateDate(feed.createdAt, '', t)}</span>}
                  content={formatLastUpdateDate(feed.createdAt, getDateTimeFormat11(), t)}
                />
              ) : (
                <span className={styles.time}>{formatLastUpdateDate(feed.createdAt, '', t)}</span>
              ))}
          </div>
        )}
        {/* show time here only for general feed comment posts, all mixr feeds, all group feeds */}
        {(level > 1 || type === 'group' || type === 'mixr') &&
          (isDesktop ? (
            <TooltipWrapper
              className='timezoneTooltip'
              position={isMobileScreen() ? 'left top' : 'top center'}
              triggerElement={
                <span className={`${styles.time} ${styles.timeInComment}`}>
                  {formatLastUpdateDate(feed.createdAt, '', t)}
                </span>
              }
              content={formatLastUpdateDate(feed.createdAt, getDateTimeFormat11(), t)}
            />
          ) : (
            <span className={`${styles.time} ${styles.timeInComment}`}>
              {formatLastUpdateDate(feed.createdAt, '', t)}
            </span>
          ))}

        {type === 'organization' && feed.relation && (
          <AnchorLink
            isNative={isNative}
            path={
              feed.relation.type === 'mixr'
                ? `/0/home/event/${feed.relation.id}`
                : feed.relation.type === 'group'
                ? `/0/home/group/${feed.relation.id}`
                : feed.relation.type === 'workplace'
                ? `/0/workplace/settings/${feed.relation.id}`
                : ''
            }
            backNavigation={true}
            className={styles.relation}>
            {feed.relation.title}
          </AnchorLink>
        )}
      </div>

      {renderOptions()}
    </div>
  )
}

export default Header
